import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LabStudio from "@/pages/LabStudio";
import Payments from "@/pages/Payments";
import Book from "@/pages/Book";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LabStudio />} />
          <Route path="/book" element={<Book />} />
          <Route path="/pay" element={<Payments />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
